/* eslint-disable unicorn/prefer-await -- established import().then() view-loader pattern */
import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alerts-show-page', () => {
  import('./internal/alerts-show-page').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.devise-form-login', () => {
  import('./internal/devise-form-login').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.users-index-page', () => {
  import('./internal/users-index-page').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('#sso_auto_redirect_form', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/sso-auto-redirect');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();
});
